module.exports = __webpack_public_path__ + "img/brand-placeholder1.3b94546.png";